import { render, staticRenderFns } from "./injuryType.vue?vue&type=template&id=c1a0542a&"
import script from "./injuryType.vue?vue&type=script&lang=js&"
export * from "./injuryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports